/**
 * LegalTemplatesPage — the Blank-legal-templates box (#3, Pedro 2026-09-13),
 * reached from the "Blank legal templates" tile on the Welcome dashboard. Holds
 * the firm's unfilled legal documents (IAA, Annexes I–IV) for download in PT/EN.
 */
import { Container, Stack } from '@mantine/core';
import { useState } from 'react';

import { BackToCompliance } from '../components/BackToCompliance';
import { BlankLegalTemplatesCard } from '../components/BlankLegalTemplatesCard';
import { DEFAULT_FEE_CALC, FeeCalculatorCard, type FeeCalcValue } from '../components/FeeCalculatorCard';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export function LegalTemplatesPage() {
  useDocumentTitle('Blank legal templates');
  // One set of calculator inputs for the page card and the Download's simulation dialog,
  // so a simulation set up on the page carries into the Annex I (Pedro 2026-10-10).
  const [calc, setCalc] = useState<FeeCalcValue>(DEFAULT_FEE_CALC);
  return (
    <Container size="xl" pt="md">
      <Stack>
        <BackToCompliance to="/" label="Back to Welcome" />
        <BlankLegalTemplatesCard calc={calc} onCalc={setCalc} />
        {/* P22 (Pedro 2026-10-10): the fee calculator lives under Templates. */}
        <FeeCalculatorCard value={calc} onChange={setCalc} />
      </Stack>
    </Container>
  );
}
